import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

import { IWarehouse } from 'app/core/locations/store/locations.model';

import { LocationWarehouseApiService } from './../../../shared/services/api/location/location-warehouse-api.service';
import { UiModule } from './../../../ui/ui.module';

@Component({
  selector: 'lum-sales-order-line-items-transfer-order-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, UiModule, MatSnackBarModule],
  templateUrl: './sales-order-line-items-transfer-order-dialog.component.html',
  styleUrls: ['./sales-order-line-items-transfer-order-dialog.component.scss'],
})
export class SalesOrderLineItemsTransferOrderDialogComponent
  implements OnInit, OnDestroy
{
  warehouses :IWarehouse[] = [];
  #selectedWarehouse :IWarehouse | null = null;
  #params :{ [key :string] :any } = {
    page: '1',
    per_page: '100',
    withWarehouseGroup: true,
  };
  #destroy$ = new Subject<void>();
  loading$ :BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private locationWarehouseApiService :LocationWarehouseApiService,
    public dialogRef :MatDialogRef<SalesOrderLineItemsTransferOrderDialogComponent>,
  ) {}

  ngOnInit() {
    this.#loadWarehouses(this.#params);
  }

  ngOnDestroy() {
    this.#destroy$.next();
    this.#destroy$.complete();
  }

  onSearchWarehouses(keyword :string) {
    this.#loadWarehouses({ ...this.#params, keyword });
  }

  onSelectWarehouse(warehouse :IWarehouse) :void {
    this.#selectedWarehouse = warehouse;
  }

  onSubmit() :void {
    this.dialogRef.close(this.#selectedWarehouse);
  }

  #loadWarehouses(params :{ [key :string] :string } = {}) :void {
    this.loading$.next(true);
    this.locationWarehouseApiService
      .getWarehouses(params)
      .pipe(takeUntil(this.#destroy$))
      .subscribe({
        next: (response) => {
          const filteredWarehouses = response.data.filter(
            (warehouse) =>
              warehouse.warehouse_groups.length === 0 ||
              warehouse.warehouse_groups.every(
                (group :any) => !group.externally_managed,
              ),
          );
          this.warehouses = filteredWarehouses;
        },
        complete: () => this.loading$.next(false),
      });
  }
}
